import { get, getValue, getLabel } from 'ice.fo.utils/GetterUtils'

export default (_, inject) => {
  inject('get', get)
  inject('getValue', getValue)
  inject('getLabel', getLabel)
}
